import { useEffect } from "react";
import { useLang } from "@/i18n";

function LegalPage({ titleKey, bodyKey, testid }) {
  const { t } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="container-x py-14 max-w-3xl" data-testid={testid}>
      <h1 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white">{t(titleKey)}</h1>
      <div className="mt-8 space-y-5">
        {t(bodyKey).map((p, i) => (
          <p key={i} className="text-zinc-400 leading-relaxed">{p}</p>
        ))}
      </div>
    </div>
  );
}

export default function Privacy() {
  return <LegalPage titleKey="privacy.title" bodyKey="privacy.body" testid="privacy-page" />;
}

export function Voorwaarden() {
  return <LegalPage titleKey="terms.title" bodyKey="terms.body" testid="terms-page" />;
}
